import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ptBR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';

const MUI_LOCALES = {
  'pt-BR': ptBR,
  en: enUS,
};

ThemeLocalization.propTypes = {
  children: PropTypes.node
};

export default function ThemeLocalization({ children }) {
  const defaultTheme = useTheme();
  const { i18n } = useTranslation();

  const muiLocale = MUI_LOCALES[i18n.language] || MUI_LOCALES['pt-BR'];

  const theme = createTheme(defaultTheme, muiLocale);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
